import React, {useEffect, useMemo, useState} from 'react';
import MainCard from "../../../utils/ui-components/MainCard";

import {useTheme} from "@mui/material/styles";
import EditIcon from '@mui/icons-material/Edit';
import {ContactService} from '../../../assets/_services/contact-service';
import { Box, Button, CircularProgress, Divider, Grid, Skeleton, Stack, TableContainer, TablePagination, Typography, styled } from '@mui/material';
import { PackageService } from '../../../assets/_services/package-service';
import { gridSpacing } from '../../../store/constants';
import { useSelector } from 'react-redux';
import { Types, getLoginSuccess, getState, loginRequest } from '../../../redux/actions/actions';
import { useDispatch } from 'react-redux';
import { closeConfirmDialog, openConfirmDialog } from '../../../utils/ui-components/pop-ups/ConfirmDialog';
import CallIcon from '@mui/icons-material/Call';
import GroupIcon from '@mui/icons-material/Group';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';
// import AttachMoneyIcon from '../../../assets/images/3cx-logo.png';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { currencyFormat } from '../../../utils/utils';
import { openSnackBar } from '../../../utils/ui-components/CustomSnackBar';
import TablePaginationActions from '@mui/material/TablePagination/TablePaginationActions';

const CardWrapper = styled(MainCard)(({theme, color}: any) => ({
    // backgroundColor: theme.palette[color].dark,
    // color: theme.palette[color].light,
    overflow: 'hidden',
    position: 'relative',
    transition: 'box-shadow 0.2s ease-in-out',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        borderRadius: '50%',
        top: -30,
        right: -180
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        borderRadius: '50%',
        top: -160,
        right: -130
    },
    '&:hover': {
        boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.2)', // Add the elevation effect here
        // Add any other styles you want to apply on mouseover
    }
}));

function PackageList() {
    const authState = useSelector((state: any) => state.auth.authData);
    const user = getState(authState);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const [isSelectLoading, setIsSelectLoading] = useState({loading : false, id : ""})
    const [packageData, setPackageData]: any = useState([]);
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [count, setCount] = useState(0)

    useEffect(() => {
        fetchPackages();
    }, [])

    useEffect(() => {
        fetchPackages();
    }, [page, rowsPerPage]);

    const fetchPackages = () => {
        setIsLoading(true)
        PackageService.getPackagesForUsers(page, rowsPerPage).then(
            response => {
                if (response.isSuccess) {
                    setCount(response.data.data.count)
                    setPackageData(response.data.data.rows)
                    setIsLoading(false)
                }
            }
        )
    }

    const changePackages = (id : string) => {
        const formData = {
            packageId : id
        }
        
        openConfirmDialog("Change Package", "Are you sure you want to change package",
        {
            action: 0,
        },
        () => {
        setIsSelectLoading({loading: true, id: id})
        closeConfirmDialog()
        PackageService.changePackage(formData).then(
            response => {
                if (response.isSuccess) {
                    const data = {
                        data : {
                            ...user,
                            isPackageSelect : id
                        },
                        errCode: null,
                        status: "success",
                        sucCode: 200,
                        comment: "success"
                    }
                    dispatch({type: Types.LOGIN_SUCCESS, payload: data});
                    setIsSelectLoading({loading: false, id: id})
                    openSnackBar('Package Changed Successfully!', 'success')
                }else{
                    setIsSelectLoading({loading: false, id: ""})
                    // openSnackBar('Package Changed Fail!', 'error')
                }
            }
        )
    })
    }

    const selectPackages = (id : string) => {
        setIsSelectLoading({loading: true, id: id})
        const formData = {
            packageId : id
        }
        PackageService.selectPackages(formData).then(
            response => {
                if (response.isSuccess) {
                    const data = {
                        data : {
                            ...user,
                            isPackageSelect : id
                        },
                        errCode: null,
                        status: "success",
                        sucCode: 200,
                        comment: "success"
                    }
                    dispatch({type: Types.LOGIN_SUCCESS, payload: data});

                    setIsSelectLoading({loading: false, id: id})
                    
                }else{
                    setIsSelectLoading({loading: false, id: ""})
                }
            }
        )
    }

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TableContainer>
            <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
            <Box style={{minHeight: '75vh'}}>
            <Grid container spacing={gridSpacing}>
                {!isLoading ? packageData.length > 0 &&
                packageData.map((item : any, index: number) => (
                    <Grid item xl={3} lg={4} md={4} sm={6} xs={12} key={index}>
                        <CardWrapper>
                            <Stack justifyContent={'space-between'} direction={'row'} alignItems={'center'}>
                                <Typography fontWeight={'bold'} variant='h4'>{(item?.packageName || "").toUpperCase()}</Typography>
                            </Stack>
                            <Divider sx={{my:2}}/>
                            <Stack direction={'column'} spacing={2}>
                                <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
                                    <Stack direction={'row'} spacing={2}>
                                        <CallIcon color='primary' fontSize='small' sx={{p:0}}/>
                                        <Typography>Concurrent calls</Typography>
                                    </Stack>
                                    <Typography>{item?.numberOfConcurrentCalls}</Typography>
                                </Stack>
                                <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
                                    <Stack direction={'row'} spacing={2}>
                                        <GroupIcon color='primary' fontSize='small' sx={{p:0}}/>
                                        <Typography>Users</Typography>
                                    </Stack>
                                    <Typography>{item?.numberOfUsers}</Typography>
                                </Stack>
                                <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
                                    <Stack direction={'row'} spacing={2}>
                                        {/* <GroupIcon color='primary' fontSize='small' sx={{p:0}}/> */}
                                        <img
                                            width="18px"
                                            src={require("../../../assets/images/3cx-logo-1.png")}
                                            alt=""
                                            style={{marginTop:5, height:'8px'}}
                                        />
                                        {/* <img src="../../../assets/images/3cx-logo.png" width={5} /> */}
                                        <Typography>3CX</Typography>
                                    </Stack>
                                    {item?.groupId3cx ?
                                        <Typography color='success.main'>Yes</Typography> :
                                        <Typography color='error.main'>No</Typography>
                                    }
                                </Stack>
                                <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
                                    <Stack direction={'row'} spacing={2}>
                                        <PhoneForwardedIcon color='primary' fontSize='small' sx={{p:0}}/>
                                        <Stack direction={'column'}>
                                            <Typography>Outbound Call</Typography>
                                            <Typography fontSize={'0.6rem'} fontWeight={'bold'} >(Without Tax)</Typography>
                                        </Stack>
                                    </Stack>
                                    <Typography>{currencyFormat(item?.outboundCallWithoutTaxes,'LKR ',2)}</Typography>
                                </Stack>
                                <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
                                    <Stack direction={'row'} spacing={2}>
                                        {/* <AttachMoneyIcon color='primary' sx={{p:0}}/> */}
                                        <PaidOutlinedIcon color='primary' fontSize='small' sx={{p:0}}/>
                                        <Stack direction={'column'}>
                                            <Typography>Rental</Typography>
                                            <Typography fontSize={'0.6rem'} fontWeight={'bold'} >(Without Tax)</Typography>
                                        </Stack>
                                    </Stack>
                                    <Typography>{currencyFormat(item?.rentalWithoutTaxes,'LKR ',2)}</Typography>
                                </Stack>
                                <Divider />
                                <Stack>
                                    <Button
                                        variant='contained'
                                        onClick={() => {
                                            if(user.isPackageSelect){
                                                changePackages(item?._id)
                                            }else{
                                                selectPackages(item?._id)
                                            }
                                        }}
                                        color='secondary'
                                        disabled={item?._id === isSelectLoading.id || isSelectLoading.loading || item?._id === user.isPackageSelect}
                                    >
                                        {item?._id === user.isPackageSelect ? "Selected" : "select"} {item?._id === isSelectLoading.id && isSelectLoading.loading && <CircularProgress size={'18px'} sx={{color: 'GrayText', ml:1}}/>}
                                    </Button>
                                </Stack>
                            </Stack>
                        </CardWrapper>
                    </Grid>
                )) : <Grid item xl={3} lg={4} md={4} sm={6} xs={12}>
                    <CardWrapper>
                    <Skeleton variant='text' />
                    <Divider sx={{mb:1}}/>
                    <Stack direction={'column'} spacing={2}>
                    <Skeleton variant='text' />
                    <Skeleton variant='text' />
                    <Skeleton variant='text' />
                    <Skeleton variant='text' />
                    <Skeleton variant='text' />
                    <Divider />
                    <Skeleton variant='rounded' width={'50%'} height={'20'} />
                    </Stack>
                    </CardWrapper>
                    </Grid>
                }
            </Grid>
            </Box>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} display='flex' >
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </Grid>
        </Grid>
        </TableContainer>
    );
}

export default PackageList;